var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var withDefaults = function (props, variantOverrides) {
    if (variantOverrides === void 0) { variantOverrides = {}; }
    return (__assign(__assign({ hideScrollbar: true, scrollHint: 0, scrollInterval: undefined, scrollStep: 'full-width', suggestiveFade: false, scrollSnapAlign: 'center' }, variantOverrides), props));
};
export var getVariantOptions = function (variant, options) {
    return {
        "default": function () { return withDefaults(options); },
        spotlight: function () { return withDefaults(options); }
    }[variant]();
};
export var getVariantOverrides = function (variant) {
    return {
        "default": function () { return ({}); },
        spotlight: function () { return ({
            maxRows: 1,
            maxColumns: 1
        }); }
    }[variant]();
};
